import { useState } from 'react'

import { useQuery } from 'providers/tanstack-query/useQuery'
import { parseFinanceData } from './api/integrity'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_FINANCE_REPORT } from './api/query'

import type { SchemaDTO } from './api/integrity'
import type { Data, Variables } from './api/types'
import type { FinanceReportRow, Props, Return } from './types'

export const useGetGetFinanceReport = ({ first, last, sort }: Props): Return => {
  const [report, setReport] = useState<FinanceReportRow[]>([])
  const [count, setCount] = useState<number>(0)

  const { isFetching } = useQuery<Variables, Data>({
    onCompleted: async ({ financeData }: Data): Promise<void> => {
      const { data, total_count }: SchemaDTO = parseFinanceData(financeData)

      setReport(fromDTO(data))
      setCount(total_count)
    },
    query: GET_FINANCE_REPORT,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
    },
  })

  return {
    count,
    isLoading: isFetching,
    report,
  }
}
